'use client';

import React from 'react';
import styles from './GlobalSwitch.module.css';

interface GlobalSwitchProps {
  checked: boolean;
  onChange: () => void;
  disabled?: boolean;
}

export const GlobalSwitch: React.FC<GlobalSwitchProps> = ({ checked, onChange, disabled }) => {
  return (
    <label className={`${styles.switch} ${disabled ? styles.disabled : ''}`}>
      <input
        type="checkbox"
        checked={checked}
        onChange={onChange}
        disabled={disabled}
      />
      <span className={styles.slider}></span>
    </label>
  );
};